import { render, staticRenderFns } from "./TemplatePosition.vue?vue&type=template&id=1bcbdec4&"
import script from "./TemplatePosition.vue?vue&type=script&lang=js&"
export * from "./TemplatePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports